<template>
  <div class="discount">
    <!-- 导航栏 -->
    <van-nav-bar :title="title" :fixed="true" :placeholder="true" />
    <!-- 活动区块列表 -->
    <div class="discount-wrapper">
      <div class="discount-lists">
        <div class="discount-block" v-for="(item,index) in arrList" :key="index">
          <div class="banner" @click="gameDateil('gamedetails',{gameid: item.gid})">
            <img v-lazy="item.img_url" alt />
          </div>
          <div class="game-cont">
            <div class="game-icon-des">
              <div class="i-game" @click="gameDateil('gamedetails',{gameid: item.gid})">
                <img v-lazy="item.icon_url" alt="今日主推" />
              </div>
              <div class="game-des" @click="gameDateil('gamedetails',{gameid: item.gid})">
                <div class="game-name-size">
                  <span class="name">{{item.game_name}}</span>
                </div>
                <div class="type-size">
                  <span
                    v-for="(item,index) in gameType(item.game_type_name)"
                    :key="index"
                    v-show="index==0"
                  >{{item}}</span>
                  <span class="line">|</span>
                  <span>{{item.package_size}}</span>
                </div>
                <div class="game-title">
                  <span>{{item.short_info}}</span>
                </div>
                <div class="dis-num">
                  <span v-for="(_item,index) in gameType(item.game_label)" :key="index">{{_item}}</span>
                </div>
              </div>
            </div>
            <div class="game-down">
              <a v-if="item.pid!=100" @click.stop="downGame(item.down_url,item.pid,item.gid)">下载</a>
              <a v-else @click.stop="downGame(item.down_url,item.pid,item.gid)">开玩</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { contTools,lyTool } from "@/mixins/contMixins";
import wapApiFun from "@/servers/wap-module/apiFun";
import comTools from "@/assets/js/until";
export default {
  name: "discount",
  mixins: [contTools,lyTool],
  data() {
    return {
      arrList: []
    };
  },
  watch: {},
  computed: {
    title: function() {
      switch (true) {
        case this.urlObj.partId == 2:
          return "超低折扣";
          break;
        case this.urlObj.partId == 3:
          return "热门推荐";
          break;
        default:
          return "热门推荐";
          break;
      }
    }
  },
  created() {
    this.initData();
  },
  methods: {
    // 初始化数据
    initData() {
      console.log("isDiscount", this.urlObj.partId);
      let data = comTools.assignObj(this.wapConfig(), {
        activity_type: this.urlObj.partId || this.$store.state.activity_type
      });
      data.sign = comTools.querySort(data);
      wapApiFun.discount_hot(data).then(res => {
        if (res.code == 200) {
          console.log("res", res);
          this.arrList = res.data;
        } else {
          this.$toast(res.msg);
        }
      });
    }
  }
};
</script>
<style lang='less' scoped>
@import "~@/assets/css/com.less";
.discount {
  width: 100%;
  min-height: 100vh;
  background-color: #f9f9f9;
  /deep/.van-nav-bar__title {
    font-weight: bold;
  }
  // 活动区块列表
  .discount-wrapper {
    width: 100%;
    height: 100%;
    position: relative;
    .discount-lists {
      width: 100%;
      margin-bottom: 100px;
      .discount-block {
        .borderRadius(0.3rem);
        .boxShadow(1px);
        margin: 0 auto;
        margin-bottom: 0.5rem;
        width: 92%;
        background-color: #fff;
        .game-cont {
          width: 100%;
          padding: 0.2rem 0;
          // background-color: #f00;
          position: relative;
          .jc-between();
          .game-icon-des {
            width: 100%;
            margin-bottom: 0.5rem;
            .jc-content(flex-start);
            .i-game {
              width: 18%;
              margin: 0 0.3rem;
              img {
                .img();
              }
            }
            .game-des {
              flex-direction: column;
              display: flex;
              .game-name-size {
                .name {
                  font-size: 0.5rem;
                  padding-right: 0.3rem;
                }
              }
              .type-size {
                .font-color();
                font-size: 0.25rem;
                .line {
                  padding: 0 3px;
                }
              }
              // .game-type {
              //   color: #999;
              //   margin-bottom: 0.1rem;
              //   span {
              //     padding-right: 0.2rem;
              //     font-size: 0.4rem;
              //   }
              // }
              .game-title {
                color: #999;
                font-size: 0.25rem;
                margin-bottom: 0.1rem;
                .ellipsis();
              }
              .dis-num {
                display: flex;
                span {
                  font-size: 0.25rem;
                  // border-radius: 0.2rem;
                  // display: inline-block;
                  padding: 1px 0.2rem;
                  margin-right: 0.2rem;
                  &:nth-of-type(1) {
                    color: #d4704e;
                    background-color: #feedde;
                  }
                  &:nth-of-type(2) {
                    color: #666;
                    background-color: #f5f5f5;
                  }
                  &:nth-of-type(3) {
                    color: #d4704e;
                    background-color: #feedde;
                  }
                }
              }
            }
          }
          .game-down {
            position: absolute;
            right: 0.3rem;
            top: 25%;
            .theme-bg-color();
            border-radius: 0.2rem;
            padding: 0.1rem 0.4rem;
            a {
              color: #fff;
            }
          }
          // &:last-child {
          //   margin-bottom: 1.5rem;
          // }
        }
        .banner {
          width: 100%;
          img {
            .img();
          }
        }
      }
    }
  }
}
</style>